import { LogLevel } from '@genesislcap/foundation-logger';
import { logger } from './logger';
/**
 * NotificationBuilder to build NotificationStructure
 * @public
 * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
 */
export class NotificationBuilder {
    /**
     * Add title to notification
     * @public
     * @param title - string
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withTitle(title) {
        this.title = title;
        return this;
    }
    /**
     * Add body details to notification
     * @public
     * @param body - string
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withBody(body) {
        this.body = body;
        return this;
    }
    /**
     * Add the creation date to notification
     * @public
     * @param createdAt - Date
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withCreatedAt(createdAt) {
        this.createdAt = createdAt;
        return this;
    }
    /**
     * Add log level to notification
     * @public
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withLogLevel(logLevel) {
        this.logLevel = logLevel;
        return this;
    }
    /**
     * Add alert to notification
     * @public
     * @param alert - boolean
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withAlert(alert) {
        this.alert = alert;
        return this;
    }
    /**
     * Add toast to notification
     * @public
     * @param notification - {@link Toast}
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withToast(toast) {
        this.toast = toast;
        return this;
    }
    /**
     * Add banner to notification
     * @public
     * @param banner - {@link Banner}
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withBanner(banner) {
        this.banner = banner;
        return this;
    }
    /**
     * Add snackbar to notification
     * @public
     * @param snackbar - {@link Snackbar}
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withSnackbar(snackbar) {
        this.snackbar = snackbar;
        return this;
    }
    /**
     * Add dialog to notification
     * @public
     * @param dialog - {@link Dialog}
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    withDialog(dialog) {
        this.dialog = dialog;
        return this;
    }
    /**
     * Build NotificationStructure
     * @public
     * @returns
     * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
     */
    build() {
        if (!this.title) {
            throw new Error('Title is required');
        }
        if (!this.body) {
            throw new Error(`Missing required param 'body'`);
        }
        let notificationStructure = {
            title: this.title,
            body: this.body,
        };
        let config = {};
        if (this.createdAt) {
            notificationStructure = Object.assign({ createdAt: this.createdAt }, notificationStructure);
        }
        if (this.logLevel in LogLevel) {
            notificationStructure = Object.assign({ logLevel: this.logLevel }, notificationStructure);
        }
        if (this.alert) {
            config = Object.assign({ alert: this.alert }, config);
            notificationStructure = Object.assign({ config }, notificationStructure);
        }
        if (this.toast) {
            config = Object.assign({ toast: this.toast }, config);
            notificationStructure = Object.assign({ config }, notificationStructure);
        }
        if (this.banner) {
            config = Object.assign({ banner: this.banner }, config);
            notificationStructure = Object.assign({ config }, notificationStructure);
        }
        if (this.snackbar) {
            config = Object.assign({ snackbar: this.snackbar }, config);
            notificationStructure = Object.assign({ config }, notificationStructure);
        }
        if (this.dialog) {
            config = Object.assign({ dialog: this.dialog }, config);
            notificationStructure = Object.assign({ config }, notificationStructure);
        }
        logger.deprecated('getNotificationBuilder', 'Use `showNotificationBanner/Dialog/Snackbar/Toast` from `@genesislcap/foundation-notifications` instead or provide a NotificationStructure object when used with an event for a notification listener.');
        return notificationStructure;
    }
}
/**
 * Returns a new NotificationBuilder instance
 * @public
 * @deprecated Use showNotificationBanner/Dialog/Snackbar/Toast instead or provide a NotificationStructure object when used with an event for a notification listener.
 */
export const getNotificationBuilder = () => new NotificationBuilder();
